export interface TranslationKeys {
    loading: string
    redirectingToLogin: string
    callEndpointAgain: string
    language: string
    user: string
    message: string
    error: string
    logout: string
    navHome: string
    navSettings: string
    navTransactions: string
    navImport: string
    navCategories: string
    navRules: string
    settingsTitle: string
    settingsDisplayName: string
    settingsEmail: string
    settingsLanguage: string
    settingsSave: string
    settingsSaved: string
    notFoundTitle: string
    notFoundMessage: string
    notFoundBack: string
    validationDisplayNameMin: string
    validationEmailInvalid: string
    authErrorTitle: string
}

const en: TranslationKeys = {
    loading: 'Loading...',
    redirectingToLogin: 'Redirecting to login...',
    callEndpointAgain: 'Call endpoint again',
    language: 'Language',
    user: 'User',
    message: 'Message',
    error: 'An error occurred',
    logout: 'Logout',
    navHome: 'Dashboard',
    navSettings: 'Settings',
    navTransactions: 'Transactions',
    navImport: 'Import',
    navCategories: 'Categories',
    navRules: 'Rules',
    settingsTitle: 'Profile Settings',
    settingsDisplayName: 'Display Name',
    settingsEmail: 'Email',
    settingsLanguage: 'Language',
    settingsSave: 'Save changes',
    settingsSaved: 'Saved successfully',
    notFoundTitle: 'Page not found',
    notFoundMessage: 'The page you are looking for does not exist or has been moved.',
    notFoundBack: 'Back to home',
    validationDisplayNameMin: 'Display name must be at least 2 characters',
    validationEmailInvalid: 'Must be a valid email address',
    authErrorTitle: 'Authentication service unavailable',
}

export default en
